import { useEffect } from "react";
import { getUserDataByToken } from "../../../store/auth/authActions";
import { GET_USER_DATA_URL } from "../../../api/apiRoutes";
import { useDispatch } from "react-redux";
import useFacility from "../../../../utils/hooks/useFacility";

export default function useMyAccount() {
  const dispatch = useDispatch();
  const facilityIds = useFacility();

  useEffect(
    () => {
      dispatch(getUserDataByToken(GET_USER_DATA_URL(facilityIds)));
    }, //eslint-disable-next-line
    []
  );
}
